import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './counter/counterSlice';
import appReducer from './Slices/appSlice';
import userReducer from './Slices/userSlice';
import purchaseReducer from './Slices/purchaseSlice';
import productReducer from './Slices/productSlice';
import eventReducer from './Slices/eventSlice';
import cityReducer from './Slices/citySlice';
import retailerReducer from './Slices/retailerSlice';
import filterReducer from './Slices/filterSlice';

export default configureStore({
  reducer: {
    counter: counterReducer,
    app: appReducer,
    user: userReducer,
    purchasePlan: purchaseReducer,
    product: productReducer,
    event: eventReducer,
    city: cityReducer,
    retailer: retailerReducer,
    filters: filterReducer,
  },
});
